import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface OrderBumpModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPack: 'basic' | 'pro';
}
export function OrderBumpModal({
  isOpen,
  onClose,
  selectedPack
}: OrderBumpModalProps) {
  const [isBumpSelected, setIsBumpSelected] = useState(false);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setIsBumpSelected(false);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const getCheckoutUrl = (withBump: boolean) => {
    if (withBump) {
      return selectedPack === 'basic' ? 'https://checkout.infinita-mente.online/cart/42842862846050:1' : 'https://checkout.infinita-mente.online/cart/42842871201890:1';
    }
    return selectedPack === 'basic' ? 'https://checkout.infinita-mente.online/cart/42842670268514:1' : 'https://checkout.infinita-mente.online/cart/42842714144866:1';
  };
  return <AnimatePresence data-id="element-187">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-188">
          {/* Overlay */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/85" data-id="element-189" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        duration: 0.5,
        bounce: 0.25
      }} className="relative w-full max-w-md z-10 overflow-hidden" data-id="element-190">
            {/* Purple glow effects */}
            <div className="absolute -top-20 -left-20 w-40 h-40 rounded-full pointer-events-none opacity-30" style={{
          background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)'
        }} data-id="element-191" />
            <div className="absolute -bottom-20 -right-20 w-40 h-40 rounded-full pointer-events-none opacity-30" style={{
          background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)'
        }} data-id="element-192" />

            {/* Card */}
            <div className="relative rounded-2xl border border-white/10 p-6 sm:p-8 flex flex-col items-center text-center" style={{
          background: 'linear-gradient(180deg, #1a1a2e 0%, #0f0f1a 100%)'
        }} data-id="element-193">
              {/* Title */}
              <h2 className="text-2xl sm:text-3xl font-extrabold text-white uppercase mb-3 leading-tight flex items-center gap-2 justify-center" data-id="element-194">
                <span className="text-2xl" data-id="element-195">🔥</span>
                <span data-id="element-196">¡Esperá! Oferta Exclusiva</span>
                <span className="text-2xl" data-id="element-197">🔥</span>
              </h2>

              <p className="text-gray-400 text-sm sm:text-base mb-8" data-id="element-198">
                Antes de finalizar, ¿querés agregar esto a tu compra?
              </p>

              {/* Product Card */}
              <div onClick={() => setIsBumpSelected(!isBumpSelected)} className={`w-full rounded-xl p-4 sm:p-5 cursor-pointer transition-all duration-300 border mb-4 ${isBumpSelected ? 'border-green-500 bg-green-500/5 shadow-[0_0_15px_rgba(34,197,94,0.1)]' : 'border-white/15 bg-[#111]/80 hover:border-white/30'}`} data-id="element-199">
                <div className="flex items-start gap-3" data-id="element-200">
                  {/* Checkbox */}
                  <div className="shrink-0 mt-0.5" data-id="element-201">
                    <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200 ${isBumpSelected ? 'border-green-500 bg-green-500' : 'border-gray-500 bg-transparent'}`} data-id="element-202">
                      {isBumpSelected && <svg className="w-3 h-3 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-203">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-204" />
                        </svg>}
                    </div>
                  </div>

                  {/* Product Info */}
                  <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-2" data-id="element-205">
                    <div className="text-left" data-id="element-206">
                      <h4 className="text-white font-extrabold text-sm sm:text-base uppercase leading-tight" data-id="element-207">
                        EL BOTÓN ROJO: PROTOCOLO DE RECUPERACIÓN
                      </h4>
                      <p className="text-gray-400 text-xs sm:text-sm mt-1 leading-relaxed" data-id="element-208">
                        Agregá la "Llave Maestra" para recuperar tus cuentas
                        incluso si el estafador ya cambió tus claves y correos
                      </p>
                    </div>
                    <span className="text-green-500 font-extrabold text-lg sm:text-xl shrink-0" data-id="element-209">
                      $5.999
                    </span>
                  </div>
                </div>
              </div>

              {/* Helper text */}
              <p className="text-gray-500 text-xs mb-6" data-id="element-210">
                Hacé click para agregar a tu pedido
              </p>

              {/* CTA Button */}
              <a href={getCheckoutUrl(isBumpSelected)} target="_blank" rel="noopener noreferrer" className={`w-full font-extrabold text-base sm:text-lg py-4 px-6 rounded-full transition-all duration-300 block text-center uppercase tracking-wide ${isBumpSelected ? 'bg-green-500 hover:bg-green-600 text-black shadow-[0_0_25px_rgba(34,197,94,0.3)]' : 'bg-transparent border-2 border-green-500 text-green-500 hover:bg-green-500/10'}`} data-id="element-211">
                {isBumpSelected ? 'Agregar y continuar →' : 'Continuar sin agregar →'}
              </a>

              {/* Back link */}
              <button onClick={onClose} className="mt-4 text-gray-500 hover:text-white text-sm transition-colors" data-id="element-212">
                ← Volver atrás
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}